import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Grid,
  IconButton,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Stack,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useSelector } from "react-redux";
import moment from "moment";
import axios from "axios";
import { CmpSelectFieldV1 } from "../../Component/Common/ToolBox/ToolBoxV1";
import { fAlertToast } from "../../Utility/Utilitys";
import {
  common_locaitonlist_API,
  ORDER_DETAIL_GETROW_API,
} from "../../Server/ApiV2";
import {
  Order_Picking_Update_Api,
  Quicksale_Get_Row_Api,
} from "../../Server/Apis";
import { httpRequest } from "../../Server/Axios";
import OrderCard from "./components/OrderCard";
import { vRdxUserInfo } from "../../Redux/roStore";
import theme from "../../Theme";
import CirlceCheckbox from "../../Component/Common/ReuseableComponent/CirlceCheckbox";

const OrderPicking = () => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const [fromDate, setFromDate] = useState(moment().subtract(1, "days"));
  const [toDate, setToDate] = useState(moment());
  const [selectedLoc, setSelectedLoc] = useState("");
  const [locations, setLocations] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [open, setOpen] = useState(false);

  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const imgBaseUrl = vRdxDBKernObj.IMAGE_BASE_URL?.Val;

  const { UserID } = useSelector((state) => state.login.value);

  const handleFilter = async () => {
    try {
      if (selectedLoc) {
        const payload = Quicksale_Get_Row_Api({
          StartDate: moment.utc(fromDate).format("MM/DD/YYYY"),
          EndDate: moment.utc(toDate).format("MM/DD/YYYY"),
          PickingStatus: "",
          DeliveryStatus: "",
          User: UserID || "",
          Loc: selectedLoc || "",
        });
        let res = await httpRequest(payload);
        if (res?.Type && res?.ResultSet)
          setFilteredOrders(res?.ResultSet || []);
      }
    } catch (error) {
      fAlertToast("FAILED", error?.response?.data?.message);
    }
  };

  const handleOpen = async (order) => {
    setSelectedOrder(order);
    setOpen(true);
    try {
      const response = await ORDER_DETAIL_GETROW_API({ ID: order?.ID || "" });
      setTableData(response.data?.ResultSet || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedOrder(null);
    setTableData([]);
  };

  const getLocation = useCallback(async () => {
    let locationList = await common_locaitonlist_API({
      usercd: UserID,
    });
    if (locationList?.status === 200) {
      if (locationList.data?.ResultSet?.length > 0) {
        setLocations(locationList?.data?.ResultSet);
        setSelectedLoc(locationList?.data?.ResultSet[0]?.UId);
      }
    }
  }, [UserID]);

  const validateBarcode = (enteredBarcode, actualBarcode) => {
    if (enteredBarcode !== actualBarcode) {
      fAlertToast("FAILED", "Invalid barcode entered!");
    } else {
      fAlertToast("SUCCESS", "Barcode validated successfully!");
    }
  };

  useEffect(() => {
    if (selectedOrder?.PickingStatus === "post") {
      // Update BarcodeInput field in tableData to match Barcode
      setTableData((prevData) =>
        prevData.map((item) => ({
          ...item,
          BarcodeInput: item.Barcode, // Set BarcodeInput to Barcode
        }))
      );
    }
  }, [selectedOrder, tableData]);

  useEffect(() => {
    handleFilter();
  }, [selectedLoc]);

  useEffect(() => {
    getLocation();
    handleFilter();
  }, []);

  return (
    <>
      {/* Filters Section */}
      <Box
        sx={{
          backgroundColor: "#f5f5f5",
          padding: 3,
          borderRadius: 2,
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
          mb: 4,
          mt: 3,
        }}
      >
        <Grid container spacing={{ xs: 1, sm: 2 }} justifyContent={"center"}>
          <Grid item xs={12} sm={6} md={3}>
            <DatePicker
              label="From Date"
              value={fromDate}
              inputFormat="DD/MM/YYYY"
              onChange={(newValue) => setFromDate(newValue || moment())}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  sx={{
                    height: "35px",
                    "& input": {
                      padding: "9px",
                    },
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DatePicker
              label="To Date"
              value={toDate}
              inputFormat="DD/MM/YYYY"
              onChange={(newValue) => setToDate(newValue || moment())}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  sx={{
                    height: "35px",
                    "& input": {
                      padding: "9px",
                    },
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CmpSelectFieldV1
              xLabelText="locations"
              xValue={selectedLoc}
              xOnChange={(e) => setSelectedLoc(e?.target?.value)}
              xName={"loc"}
              xData={locations ?? []}
              sx={{ height: "100%" }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: { xs: "center", md: "flex-start" },
            }}
          >
            <Button variant="contained" color="primary" onClick={handleFilter}>
              Apply Filters
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Typography variant="pageTitle" color="primary">
        Order Picking
      </Typography>
      {/* Orders Section */}
      <Box>
        <Grid container spacing={1} mt={1}>
          {filteredOrders.length > 0 &&
            filteredOrders?.map((order) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                lg={2.4}
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", sm: "flex-start" },
                }}
                key={order.ID}
              >
                <OrderCard order={order} handleOpen={handleOpen} />
              </Grid>
            ))}
        </Grid>
      </Box>

      {/* Dialog Section */}
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle
          sx={{
            fontWeight: "bolder",
            backgroundColor: "#1976d2",
            color: "#fff",
            padding: 2,
          }}
        >
          {selectedOrder ? `Order ID - ${selectedOrder.ID}` : "Order Details"}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 16,
              top: 16,
              color: "#fff",
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box>
            <Box
              sx={{
                backgroundColor: "#f9f9f9",
                padding: 1,
                borderRadius: 2,
                boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
                my: 2,
              }}
            >
              <Stack direction="row" justifyContent={"space-between"}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bolder",
                    mb: 1,
                    color: theme.palette.primary.main,
                  }}
                >
                  Order Information
                </Typography>
                <CirlceCheckbox
                  status={selectedOrder?.PickingStatus.toUpperCase()}
                />
              </Stack>
              <Grid container spacing={2}>
                {/* First Column */}
                <Grid item xs={12} sm={6}>
                  <Box display="flex" flexDirection="column" gap={0.5}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "bolder",
                          flex: "1",
                          color: "#000",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Order ID
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          flex: "1",
                          color: "#000",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.ID}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "bolder",
                          flex: "1",
                          color: "#000",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Date
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          flex: "1",
                          color: "#000",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {moment(selectedOrder?.OrderTime).format("DD-MM-YYYY")}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "bolder",
                          flex: "1",
                          color: "#000",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        User
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          flex: "1",
                          color: "#000",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.OrderUserName}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "bolder",
                          flex: "1",
                          color: "#000",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Car Model
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          flex: "1",
                          color: "#000",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.CarModel}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "bolder",
                          flex: "1",
                          color: "#000",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Location
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          flex: "1",
                          color: "#000",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.LocName}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                {/* Second Column */}
                <Grid item xs={12} sm={6}>
                  <Box display="flex" flexDirection="column" gap={0.5}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "bolder",
                          flex: "1",
                          color: "#000",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Car No
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          flex: "1",
                          color: "#000",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.CarNo}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "bolder",
                          flex: "1",
                          color: "#000",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Mobile No
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          flex: "1",
                          color: "#000",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.MobileNo}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "bolder",
                          flex: "1",
                          color: "#000",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Delivery Person
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          flex: "1",
                          color: "#000",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.DeliveryPerson}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <TableContainer sx={{ mt: 3 }}>
              <Table>
                <TableHead>
                  <TableRow
                    sx={{
                      backgroundColor: "#fff",
                    }}
                  >
                    {[
                      "Image",
                      "Bar Code",
                      "Validate Barcode",
                      "Item Name",
                      "Order Qty",
                      "Picked Qty",
                    ].map((heading, index) => (
                      <TableCell
                        key={index}
                        sx={{
                          color: "#000",
                          fontWeight: "bolder",
                          textAlign: "center",
                          padding: "8px !important",
                        }}
                      >
                        {heading}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData?.map((row, index) => (
                    <TableRow
                      key={index}
                      hover
                      sx={{
                        backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
                      }}
                    >
                      <TableCell
                        align="center"
                        sx={{
                          // fontSize: "0.7rem",
                          // padding: "8px !important",
                          width: "80px !important",
                          height: "80px !important",
                        }}
                      >
                        <img
                          src={`${imgBaseUrl}Products/${row?.SuppRefNo1}.jpg`}
                          alt={row?.ItmCd}
                          loading="lazy"
                          style={{
                            objectFit: "contain",
                            borderRadius: "50%",
                            width: "100%",
                            height: "100%",
                            cursor: "pointer",
                          }}
                        />
                      </TableCell>
                      {/* Barcode Column */}
                      <TableCell
                        align="center"
                        sx={{ fontSize: "0.7rem", padding: "8px !important" }}
                      >
                        {row.Barcode}
                      </TableCell>
                      {/* Barcode Input Column */}
                      <TableCell
                        align="center"
                        sx={{ fontSize: "0.7rem", padding: "8px !important" }}
                      >
                        <Checkbox
                          checked={row.BarcodeInput === row.Barcode}
                          disabled={selectedOrder?.PickingStatus === "post"}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setTableData((prevData) =>
                                prevData.map((item, i) =>
                                  i === index
                                    ? { ...item, BarcodeInput: item.Barcode }
                                    : item
                                )
                              );
                              validateBarcode(row.Barcode, row.Barcode);
                            } else {
                              // Reset BarcodeInput if unchecked
                              setTableData((prevData) =>
                                prevData.map((item, i) =>
                                  i === index
                                    ? { ...item, BarcodeInput: "" }
                                    : item
                                )
                              );
                            }
                          }}
                        />
                        <TextField
                          variant="outlined"
                          size="small"
                          value={row.BarcodeInput || ""}
                          disabled={row?.BarcodeInput === row?.Barcode}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (
                              row?.Barcode === e.target.value &&
                              selectedOrder?.PickingStatus !== "post"
                            ) {
                              validateBarcode(e.target.value, row?.Barcode);
                            }
                            setTableData((prevData) =>
                              prevData.map((item, i) =>
                                i === index
                                  ? { ...item, BarcodeInput: value }
                                  : item
                              )
                            );
                          }}
                          onKeyDown={(e) => {
                            if (
                              e.key === "Enter" &&
                              selectedOrder?.PickingStatus !== "post"
                            ) {
                              validateBarcode(row.BarcodeInput, row.Barcode);
                            }
                          }}
                          inputProps={{
                            style: { textAlign: "center" }, // Center the input value
                          }}
                          sx={{
                            maxWidth: "120px",
                          }}
                        />
                      </TableCell>
                      {/* Item Name Column */}
                      <TableCell
                        align="center"
                        sx={{
                          fontSize: "0.7rem",
                          padding: "8px !important",
                          width: "150px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {row.ItmName}
                      </TableCell>
                      {/* Order Quantity Column */}
                      <TableCell
                        align="center"
                        sx={{ fontSize: "0.7rem", padding: "8px !important" }}
                      >
                        {row.Qty}
                      </TableCell>
                      {/* Picked Quantity Column */}
                      <TableCell
                        align="center"
                        sx={{ fontSize: "0.7rem", padding: "8px !important" }}
                      >
                        <TextField
                          variant="outlined"
                          size="small"
                          type="number"
                          value={row.InvQty}
                          onFocus={(e) => {
                            // Clear the value if it is 0 when the input gains focus
                            if (e.target.value === "0") {
                              setTableData((prevData) =>
                                prevData.map((item, i) =>
                                  i === index
                                    ? {
                                        ...item,
                                        InvQty: "",
                                      }
                                    : item
                                )
                              );
                            }
                          }}
                          onBlur={(e) => {
                            // Restore the value to 0 if the input loses focus and is empty
                            if (e.target.value === "") {
                              setTableData((prevData) =>
                                prevData.map((item, i) =>
                                  i === index
                                    ? {
                                        ...item,
                                        InvQty: 0,
                                      }
                                    : item
                                )
                              );
                            }
                          }}
                          onChange={(e) => {
                            let value = e.target.value;
                            setTableData((prevData) =>
                              prevData.map((item, i) =>
                                i === index
                                  ? {
                                      ...item,
                                      InvQty: parseInt(value),
                                    }
                                  : item
                              )
                            );
                          }}
                          onKeyDown={(e) => {
                            // Prevent users from typing 'e', '+', '-' or other invalid characters
                            if (
                              e.key === "e" ||
                              e.key === "+" ||
                              e.key === "-"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          inputProps={{
                            style: { textAlign: "center" }, // Center the input value
                          }}
                          sx={{
                            maxWidth: "80px",
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </DialogContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 2,
            borderTop: "1px solid #e0e0e0",
          }}
        >
          <Button
            variant="contained"
            color="success"
            disabled={selectedOrder?.PickingStatus === "post"}
            onClick={async () => {
              try {
                const totalInvQty = tableData.reduce(
                  (sum, item) => sum + (item.InvQty || 0),
                  0
                );
                if (totalInvQty <= 0) {
                  fAlertToast(
                    "FAILED",
                    "You cannot save with a sum of picking quantity less than or equal to 0!"
                  );
                  return;
                }
                // Validate barcode
                const validateBarcodes = tableData.every(
                  (item) => item.BarcodeInput === item.Barcode
                );
                if (!validateBarcodes) {
                  fAlertToast("FAILED", "All barcodes must be validated!");
                  return;
                }
                const obj = Order_Picking_Update_Api({
                  ID: selectedOrder?.ID,
                  PickingUser: vRdxUserInfoObj.UserID || "",
                  Details: tableData?.map((item) => ({
                    ItmCd: item.ItmCd,
                    v_InvQty: item.InvQty,
                    ConfirmBarcode: item.BarcodeInput,
                  })),
                });
                let res = await httpRequest(obj);
                if (res?.Type && res?.ResultSet) {
                  fAlertToast("SUCCESS", res?.Type);
                  handleClose(); // Close the modal after success
                  handleFilter();
                }
              } catch (error) {
                fAlertToast("FAILED", error?.response?.data?.message);
              }
            }}
          >
            Complete
          </Button>
        </Box>
      </Dialog>
    </>
  );
};

export default OrderPicking;
